// src/components/shared/PageBack.js
// Single back-button component used at the TOP and BOTTOM of every page,
// so people never have to scroll a long list back up (or down) just to
// go back a screen. Two positions, one component, one place to fix it.

import React from 'react';
import { useNavigate } from 'react-router-dom';

// position: 'top' (inline, scrolls with content) | 'bottom' (fixed, floats above content)
// label: text shown next to the arrow (defaults to 'Back')
// fallbackPath: where to go if there's no browser history to go back to
export const PageBack = ({ position = 'top', label = 'Back', fallbackPath = '/' }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 2) navigate(-1);
    else navigate(fallbackPath);
  };

  if (position === 'bottom') {
    return (
      <div style={bottomWrap}>
        <button onClick={handleBack} style={bottomBtn} aria-label={label}>
          <span aria-hidden="true">←</span> {label}
        </button>
      </div>
    );
  }

  return (
    <button onClick={handleBack} style={topBtn} aria-label={label}>
      <div style={topCircle}>←</div>
      <span style={topLabel}>{label}</span>
    </button>
  );
};

const topBtn = {
  display: 'flex', alignItems: 'center', gap: 8,
  background: 'none', border: 'none', cursor: 'pointer',
  marginBottom: 16, padding: 0, fontFamily: 'Nunito, sans-serif',
};
const topCircle = {
  width: 34, height: 34, background: 'var(--white)', borderRadius: '50%',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  fontSize: 15, color: 'var(--sage-dark)', boxShadow: 'var(--shadow-sm)',
};
const topLabel = { fontSize: 13, color: 'var(--muted)', fontWeight: 600 };

const bottomWrap = {
  position: 'sticky', bottom: 12, left: 0, width: '100%',
  display: 'flex', justifyContent: 'center', marginTop: 24, zIndex: 90,
};
const bottomBtn = {
  display: 'flex', alignItems: 'center', gap: 8,
  background: 'var(--white)', border: '1.5px solid var(--border)',
  borderRadius: 100, padding: '10px 20px',
  fontSize: 13, fontWeight: 700, color: 'var(--sage-dark)',
  cursor: 'pointer', fontFamily: 'Nunito, sans-serif',
  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
};

export default PageBack;
